import { fromJS } from 'immutable';
import * as actions from '../utils/Constants'

export default (state = getInitialState(), action) => {
    switch (action.type) {

        case actions.DELETE_TRAINING + actions.FULFILLED:
        case actions.GET_TRAININGS + actions.FULFILLED:
            {
                return state.set('list', fromJS(action.payload));
            }
        case actions.GET_TRAININGS_POCS + actions.FULFILLED:
            {
                return state.set('pocs', fromJS(action.payload));
            }
        case actions.UPDATE_TRAININGS_SELECTED_PROGRAMS:
            {
                return state.setIn(['criteria', 'selectedPrograms'], action.payload);
            }
        case actions.UPDATE_TRAININGS_SELECTED_TRAININGTYPES:
            {
                return state.setIn(['criteria', 'selectedTrainingTypes'], action.payload);
            }
        default:
            return state;
    }
}

const getInitialState = () => {
    return fromJS({
        list: [],
        pocs: [],
        criteria: {
            stateId: 0,
            selectedPrograms: [],
            selectedTrainingTypes: []
        }
    }) 
       

}